import { render } from "./NewestProjects.vue?vue&type=template&id=280eba86"
import script from "./NewestProjects.vue?vue&type=script&lang=js"
export * from "./NewestProjects.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wallace/Desktop/projects/virtap/virtap-webapp-assistant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__